import { toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';
import { defaultBreakpoints } from '../themes/theme-keys/breakpoints.esm.js';
import { isNotEmptyObject, isNumeric } from '../utils/assertion.esm.js';
import { toNumber } from '../utils/number.esm.js';
import { memoizedGet } from '../utils/object.esm.js';

var getLhCrop = function getLhCrop(value) {
  return {
    '&:before': {
      content: '""',
      display: 'block',
      height: 0,
      width: 0,
      marginTop: "-".concat(Array.isArray(value) ? value[0] : value, "em")
    },
    '&:after': {
      content: '""',
      display: 'block',
      height: 0,
      width: 0,
      marginTop: "-".concat(Array.isArray(value) ? value[1] : value, "em")
    }
  };
};
function parseNumericArray(value) {
  if (typeof value === 'string' && value.includes(',')) {
    var values = value.split(',');
    return values.length === 2 && isNumeric(values[0]) && isNumeric(values[1]) ? [toNumber(values[0]), toNumber(values[1])] : undefined;
  }
  return isNumeric(value) ? toNumber(value) : undefined;
}
function lhCropTransform (value, scale, _props) {
  var lhCorp = parseNumericArray(value) || memoizedGet(scale, value);
  if (Array.isArray(lhCorp) && Array.isArray(lhCorp[0])) {
    var breakpoints = memoizedGet(_props, 'theme.breakpoints', defaultBreakpoints);
    var mediaQueries = [''].concat(_toConsumableArray(breakpoints.map()));
    var test = mediaQueries.reduce(function (acc, cur, idx) {
      return _objectSpread2(_objectSpread2({}, acc), idx === 0 ? _objectSpread2({}, isNotEmptyObject(lhCorp[idx]) ? getLhCrop(lhCorp[idx]) : {}) : isNotEmptyObject(lhCorp[idx]) ? _defineProperty({}, cur, getLhCrop(lhCorp[idx])) : {});
    }, {});
    return test;
  }
  return lhCorp ? getLhCrop(lhCorp) : '';
}

export default lhCropTransform;
//# sourceMappingURL=lh-crop-transform.esm.js.map
